module.exports = __webpack_public_path__ + "img/about-3.2fc0f455.png";